<template>
  <div class="container" v-if="top_picks && top_picks.length > 0">
    <div class="row">
      <div class="col">
        <VueSlickCarousel v-bind="top_picks_setting">
          <div v-for="(item, i) in top_picks" :key="i">
            <section :id="'item' + item.item_id">
              <div>
                <Product
                  :key="item.item_id"
                  :item="item"
                  :right="true"
                  v-on:openProductDetailModal="openProductDeails"
                  :restaurantID="item.restaurant_id"
                  :restaurant_on_off="'1'"
                  :class="item.item_id"
                  :pagename="'itemslist'"
                  :itemlayout="1"
                ></Product>
              </div>
            </section>
          </div>
        </VueSlickCarousel>
      </div>
    </div>
    <ProductDetails
      v-if="restaurant_id && restaurant_id != ''"
      ref="childComponent"
      :restaurantID="restaurant_id"
      :pagename="'itemslist'"
    ></ProductDetails>
    <!-- {{ top_picks }} -->
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
//   import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import Product from "@/components/Product.vue";
import { imageErrorHandle } from "../helper/helper.js";
import ProductDetails from "@/components/ProductDetails.vue";

export default {
  name: "TopPicks",
  props: ["top_picks", "restaurant_on_off", "restaurant_id"],
  components: { VueSlickCarousel, Product, ProductDetails },
  data() {
    return {
      itemlayout: "1",
      imageErrorHandle: imageErrorHandle,
      top_picks_setting: {
        dots: true,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 0,
        centerMode: false,
        centerPadding: "40px",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 650,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
              infinite: false,
            },
          },
        ],
      },
    };
  },
  methods: {
    openProductDeails(value) {
      window.$("#item-popup").modal("show");
      window.$("#item-popup").on("hidden.bs.modal", () => {
        this.$refs.childComponent.productDetail = null;
        this.$refs.childComponent.selectedCustomisation = {
          customize_type: {},
        };
      });
      this.$refs.childComponent.openProductModel(
        value.item_id,
        value.item_name
      );
    },
  },
  mounted() {
    this.itemlayout =
      this.$auth.setting && this.$auth.setting.restaurant_item_layout;
    if (this.itemlayout == "") {
      this.itemlayout = 1;
    }
  },
};
</script>
<style scoped>
.item_detail {
  min-height: 161px !important;
}
</style>
